import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

type Lookup = {
    id: number
    name_th: string
    name_en: string
}

const useUsergroupFilterREC = () => {
    const callApi = useCallApi()
    const [usergroupFilterREC, setUsergroupFilterREC] = useState<Lookup[]>([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet({
                url: umServinceURL.getLookupUserGroupFilterByREC,
            })
            setUsergroupFilterREC(data.result as Lookup[])
        } catch (error) {
            console.log('error', error)
        }
    }

    return { usergroupFilterREC }
}

export default useUsergroupFilterREC
